import { RefObject, useEffect, useRef, useState } from 'react'

const SCROLL_THRESHOLD = 20
const BOTTOM_THRESHOLD = 20

export function useScrollDirection(element: string | RefObject<HTMLElement>) {
  const [isGoingDown, setIsGoingDown] = useState(false)
  const lastScrollTop = useRef(0)
  const directionIsDown = useRef(false)
  const [isAtBottom, setIsAtBottom] = useState(false)

  const dom =
    typeof element === 'string'
      ? document.getElementById(element)
      : element.current

  const onScrollEvent = (event: Event) => {
    const target = (event.target ||
      event.currentTarget) as HTMLDivElement | null
    if (!target) return
    const { scrollTop, scrollHeight, offsetHeight } = target
    const isScrolled =
      Math.abs(scrollTop - lastScrollTop.current) > SCROLL_THRESHOLD

    // To ignore iOS overScrolling when scroll reaches to edges
    if (scrollTop < 0 || scrollTop + offsetHeight > scrollHeight) {
      lastScrollTop.current = scrollTop
      return
    }
    if (!isScrolled) return

    const newDirection = scrollTop > lastScrollTop.current

    lastScrollTop.current = scrollTop

    if (scrollHeight - scrollTop - offsetHeight < BOTTOM_THRESHOLD) {
      setIsAtBottom(true)
    } else {
      setIsAtBottom(false)
    }

    if (directionIsDown.current !== newDirection) {
      directionIsDown.current = newDirection
      setIsGoingDown(directionIsDown.current)
    }
  }

  useEffect(() => {
    dom?.addEventListener('scroll', onScrollEvent)
    return () => dom?.removeEventListener('scroll', onScrollEvent)
  }, [dom])

  return { isGoingDown, isAtBottom }
}
